export const actions = {
  set_state: 'topup/set_state',
  get_prices: 'topup/get_prices',
  top_up: 'topup/topup',
  get_transaction: 'topup/get_transaction'
}
